//@flow
export const dataSetActionTypes = {
  UPDATE_DATA_SET: "UPDATE_DATA_SET",
  LOAD_DATA_SETS: "LOAD_DATA_SETS",
  CHANGE_DATA_SET: "CHANGE_DATA_SET",
};

export type DataSetActionType = $Keys<typeof dataSetActionTypes>;
